<template>
  <header class="app-header" id="topbar">
    <b-container>
      <div class="top-bar-container" align-h="between" v-if="!isLoading">
        <div sm="2">
          <div class="logo">
            <b-btn variant="flat" @click="gotoHome" class="float-left p-0">
              <logo class="logo-svg topbar-brand-icon"></logo>
            </b-btn>
            <h2 class="app-name">Admin Panel v{{appInfo.APP_VERSION}}</h2>
          </div>
        </div>
        <div class="top-menu-bar" >
          <b-navbar toggleable="sm" type="light">
            <b-navbar-toggle target="nav_collapse" />
            <b-collapse is-nav id="nav_collapse">
              <b-navbar-nav class="left-menu">
                <b-nav-item-dropdown v-for="(route, index) in getMenus" :class="[ $route.path.indexOf(route.path) > -1 ? 'menuItem active' : 'menuItem']" v-bind:text="route.name" :key="index" no-caret>
                  <div class="arrow"></div>
                  <b-dropdown-item v-for="(rChild, childIndex) in route.children" :key="childIndex" @click="gotoPage(rChild)" class="">
                    <a tag="li"  class="submenu-item" v-html="menuTitle(rChild.name)"></a>
                  </b-dropdown-item>
                </b-nav-item-dropdown>
                <a @click="gotoPage({page:'activityLog'})" class="nav-link" :class="[ $route.path.indexOf('activity') > -1 ? 'menuItem active' : 'menuItem']">Activity Log</a>
              </b-navbar-nav>
          </b-collapse>
        </b-navbar>
        </div>
        <div sm="4">
          <div class="user-menu">
            <a id="exPopover4">
              <img class="prof-pic" :src="appInfo.profilePicURL">
            </a>
          </div>
          <div class="top-menu text-right">
            <ul class="list-inline">
              <li>
                <a v-b-tooltip.hover title="Switch to old panel" :href="appInfo.APP_URL_V2">
                  <switch-icon class="icon switch-icon"></switch-icon>
                </a>
              </li>
              <li v-if="currentUserInfo.accessLevel == 'admin'">
                <a id="exPopover3" v-b-tooltip.hover title="IWP update centre">
                  <update-icon class="icon"></update-icon>
                  <span class="badge" v-if="updateInfo">1</span>
                </a>
              </li>
              <li v-if="currentUserInfo.accessLevel == 'admin'">
                <a @click="gotoPage({page:'addons'})" v-b-tooltip.hover title="IWP Addons page">
                  <addon-icon class="icon"></addon-icon>
                  <span class="badge" v-if="addonsInfo">{{addonsInfo}}</span>
                </a>
              </li>

              <li>
                <a @click="showSettings()">
                  <cog-icon class="icon-default cog-icon"></cog-icon>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <b-popover target="exPopover3" class="updatepopover" placement="bottomleft" triggers="click" container="topbar" @updateNow="updateNow" @show="resetDefaults">
          <b-card class="updatecard">

            <div v-if="isUpdating">
              <iframe style="min-height: 340px;
    min-width: 100%;" :src="serverURL+'update.php?action=appUpdate&newVersion='+updateInfo.newVersion"></iframe>
            </div>

            <div v-else>
              <b-card-body class="version-wrapper">
                <div v-if="updateInfo">
                  <div class="version">
                    <div class="version-number">
                      {{updateInfo.newVersion}}
                    </div>
                    <div class="new-version-text">
                      New version available
                    </div>
                  </div>
                  <div class="mini-change-log" v-html="updateInfo.updateDetails[updateInfo.newVersion].breifDescr">

                  </div>
                  <div class="changelog-link-cont">
                    <a :href="updateInfo.updateDetails[updateInfo.newVersion].changeLogLink" target="_blank"> View change log</a>
                  </div>
                </div>
                <div v-else>
                  <p class="card-text">Your panel is up-to-date.</p>
                </div>
              </b-card-body>
              <b-card-footer>
                <b-button variant="outline-secondary" size="sm" @click="checkUpdate">Check Update
                  <spinner size="small" v-if="buttonLoaders.checkUpdate"></spinner>
                </b-button>
                <b-button variant="primary" v-if="updateInfo" size="sm" @click="updateNow">Update Now</b-button>
              </b-card-footer>
            </div>
          </b-card>
        </b-popover>
        <b-popover target="exPopover4" class="logoutpopover" triggers="click blur" placement="bottomleft" container="topbar">
          <b-card class="usermenu">
              <img class="prof-pic" :src="appInfo.profilePicURL">
              <div class="user-name mt-3">{{appInfo.userInfo.name}}</div>
              <div class="user-email mt-3">{{appInfo.userInfo.email}}</div>
              <hr class="mt-4">
            <ul>
              <li class="usermenu-title">
                <report-icon class="icon-default menu-icon "></report-icon>
                <a @click="reportIssue" href="#" class="logout">Help & Report Issue</a>
              </li>
              <li class="usermenu-title">
                <idea-icon class="icon-default  menu-icon"></idea-icon>
                <a :href="'https://trello.com/b/V6VVdo7i/infinitewp-ideas'" target="_blank" class="logout">Got an idea?</a>
              </li>
              <!-- <li class="usermenu-title">
                <share-icon class="icon-default  menu-icon"></share-icon>
                <a href="#"   class="logout">Share InfiniteWP</a>
              </li> -->
              <li class="usermenu-title">
                <logout-icon class="icon-default menu-icon "></logout-icon>
                <a :href="appInfo.APP_URL+'login.php?logout=now'" class="logout">Log out</a>
              </li>
            </ul>
          </b-card>
        </b-popover>
      </div>
    </b-container>
    <settings ref="settingsmodal"></settings>
    <report-issue ref="reportissue" :issueType="'userIssue'"></report-issue>
  </header>
</template>

<script>
import logo from '../assets/logo.svg';
import switchIcon from '../assets/switch.svg';

import cogIcon from '../assets/cog.svg';
import addonIcon from '../assets/addon.svg';
import updateIcon from '../assets/update.svg';
import bellIcon from '../assets/bell.svg';
import routes from '../router/routes';
import logoutIcon from '../assets/logout.svg';
import ideaIcon from '../assets/idea.svg';
import reportIcon from '../assets/report.svg';
import shareIcon from '../assets/share.svg';
import ReportIssue from './modals/ReportIssue.vue';

export default {
  name: 'Topbar',
  components: {
    logo,
    cogIcon,
    addonIcon,
    updateIcon,
    bellIcon,
    switchIcon,
    logoutIcon,
    ideaIcon,
    reportIcon,
    shareIcon,
    ReportIssue
  },
  props: ['isLoading'],
  mounted() {
    window.eventHub.$on('updateAvailable', event => {
      this.$store.dispatch('SET_PANEL_UPDATE_INFO', event.update);
    });
  },
  data() {
    return {
      isUpdating: false,
      serverURL: window.serverURL,
      buttonLoaders: {
        checkUpdate: false
      },
      topMenu: [
        {
          name: 'Updates',
          href: '#updates',
          count: 1
        },
        {
          name: 'Notification',
          href: '#notification',
          count: 1
        },
        {
          name: 'Addons',
          href: '#addons',
          count: 1
        },
        {
          name: 'Settings',
          href: '#settings',
          count: 0
        }
      ]
    };
  },
  computed: {
    updateInfo() {
      let updateInfo = this.$store.getters.getPanelUpdateInfo;
      return updateInfo;
    },
    addonsInfo() {
      let updateInfo = this.$store.getters.getAddonsUpdateInfo;
      return updateInfo;
    },
    appInfo() {
      return this.$store.getters.getAppInfo;
    },
    getMenus(){
        return this.$store.getters.getTopBarMenus;
    },
    siteUpdatesCount() {
      let updates = this.$store.getters.getSitesUpdates;
      return updates.length;
    },
    recentCommentsCount() {
      return this.$store.getters.getRecentCommentsCount;
    },
    currentUserInfo(){
      return this.$store.getters.getCurrentUserInfo;
    }
  },
  methods: {
    showSettings() {
      this.$refs.settingsmodal.$refs.settingsmodal.show();
    },
    resetDefaults() {
      this.isUpdating = false;
    },
    gotoHome() {
      this.$router.push({ name: 'Home' });
    },
    updateNow() {
      this.isUpdating = true;
    },
    checkUpdate() {
      this.buttonLoaders.checkUpdate = true;
      let payload = {
        requiredData: {
          forceCheckUpdateV3: 1,
          getAddonAlertCount:1
        }
      };
      this.$store.dispatch('sendAction', payload).then(response => {
        let update = response.data.forceCheckUpdateV3;
        this.$store.commit('SET_PANEL_UPDATE_INFO', update);
        this.$store.commit('SET_ADDONS_UPDATE_INFO', response.data.getAddonAlertCount);
        this.buttonLoaders.checkUpdate = false;
      });
    },
    gotoPage(route) {
      this.$router.push({ name: 'Manage', params: { slug: route.page } });
    },
    menuTitle(name){
      if (name == "Updates") {
        return "Updates <span class='updates-count'>"+this.siteUpdatesCount+"</span>";
      }
      if (name == "Comments") {
        return "Comments <span class='updates-count'>"+this.recentCommentsCount+"</span>";
      }
      return name;
    },
    reportIssue(){
      this.$refs.reportissue.$refs.reportissuemodal.show();
    }
  }
};
</script>
<style lang="scss">
  
a:not([href]):not([tabindex]) {
  color: white;
}

</style>
